"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = exports.default = {
  props: {
    /* 列表数据源 */
    dataSource: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 操作按钮 */
    operations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /* 设置左侧树图，数据源 */
    treeSource: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 设置左侧树图，对象参数参考 https://element.eleme.cn/2.13/#/zh-CN/component/tree#attributes */
    treeOptions: {
      type: [Boolean, Object],
      default: false
    },
    /* 设置搜索条件树图 */
    searchOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 设置表格，对象参数参考 https://element.eleme.cn/2.13/#/zh-CN/component/table#attributes */
    tableOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 设置表格，对象参数参考 https://element.eleme.cn/2.13/#/zh-CN/component/pagination#attributes */
    paginationOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 查询条件列表 */
    query: {
      typeof: Array,
      default: function _default() {
        return [];
      }
    },
    /* 表格表头列设置 */
    columns: {
      typeof: Array,
      default: function _default() {
        return [];
      }
    },
    /* 表格操作列行按钮设置 */
    rowOperations: {
      typeof: Array,
      default: function _default() {
        return [];
      }
    },
    queryListNode: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};